export default __webpack_public_path__ + "static/media/horizontal5.585008b8.JPG";